module.exports = __webpack_public_path__ + "img/christmas-lights-2021-1.7044c520.jpg";